import { render } from "./SuggestionsManagement.vue?vue&type=template&id=0b2ae9e0&scoped=true"
import script from "./SuggestionsManagement.vue?vue&type=script&lang=js"
export * from "./SuggestionsManagement.vue?vue&type=script&lang=js"

import "./SuggestionsManagement.vue?vue&type=style&index=0&id=0b2ae9e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2ae9e0"]])

export default __exports__